'use strict';

module.exports = /*@ngInject*/ ["$resource", "$http", "ProjectService", function ($resource, $http, ProjectService) {
    var factory = {};

    factory.queryDashboard = function (tripIds, url) {
        var adjustedUrl = url.replace(':projectId', ProjectService.getSelectedProjectId());
        return $http.post(adjustedUrl, {'tripIds': tripIds});
    };

    factory.getGrid = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/grid');
    };

    factory.getDashboardTiles = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/slas');
    };

    factory.getFairUseExceedPerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/users/exceeded');

    };

    factory.getDailyFairUseExceedPercentagePerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/percentage/users/exceeded');

    };

    factory.getUserSpreadPerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/users/spread');

    };

    factory.getConsumptionPerOperator = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/consumption/operator');
    };

    factory.getAvgConsumptionPerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/consumption/avg/class');

    };

    factory.getDailyConsumptionPerOperator = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/total/consumption/operator');

    };

    factory.getDailyConsumptionPercentagePerOperator = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/percentage/consumption/operator');
    };


    factory.getSpectrumBandUsagePerModem = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/spectrum-band-usage-per-modem');
    };

    factory.getDailyUserSpreadPerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/total/users/spread');

    };

    factory.getDailyUserSpreadPercentagePerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/percentage/users/spread');

    };

    factory.getDailyAvgConsumptionPerClass = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/total/consumption/class');
    };

    factory.getQoEDailyAvgUserThroughput = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/qoe/avg/users/tput');
    };

    factory.getQoEDailyUserThroughputPercentile = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/qoe/percentile/users/tput');
    };

    factory.getQoEDailyVuTimePercentile = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/qoe/percentile/vu/time');
    };

    factory.getQoEDailyVuTimeAvg = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/qoe/avg/vu/time');
    };

    factory.getQoEDailyAvgLatency = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/qoe/avg/latency');
    };

    factory.getDailySlaValues = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/daily/sqi');
    };

    factory.getAverageSlasPerTrain = function (tripIds) {
        return factory.queryDashboard(tripIds, 'rest/advanced/trips/dashboard/:projectId/sla/avg/pertrain');
    };

    return factory;
}];
